module.exports = __webpack_public_path__ + "img/intro-image.48ce9309.png";